var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopilotSuggest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 19.25C3.25 19.6625 3.5875 20 4 20H7C7.4125 20 7.75 19.6625 7.75 19.25V18.5H3.25V19.25Z",
    fill: "#1777CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.555C1.1425 13.6025 0.25 12.035 0.25 10.25C0.25 8.10838 1.53879 6.26227 3.38157 5.44647C3.7245 5.29466 4.10977 5.48076 4.25447 5.82675C4.42754 6.24061 4.18646 6.70812 3.78758 6.91338C2.57796 7.53584 1.75 8.79682 1.75 10.25C1.75 11.4725 2.35 12.62 3.3625 13.325L4 13.775V15.5H7V13.775L7.6375 13.325C7.94797 13.1088 8.21966 12.851 8.44715 12.5622C8.71589 12.2211 9.19546 12.0704 9.56852 12.2928C9.90531 12.4935 10.0318 12.9256 9.80713 13.2469C9.45162 13.7553 9.00842 14.1983 8.5 14.555V16.25C8.5 16.6625 8.1625 17 7.75 17H3.25C2.8375 17 2.5 16.6625 2.5 16.25V14.555Z",
    fill: "#1777CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4919 10.3633L12.5318 12.8794C12.7607 13.4402 13.4932 13.4402 13.7221 12.8794L14.762 10.3633L17.051 9.2202C17.5611 8.96139 17.5611 8.16341 17.051 7.91179L14.762 6.76873L13.7221 4.25256C13.4867 3.69181 12.7607 3.69181 12.5318 4.25256L11.492 6.76873L9.20293 7.91179C8.6928 8.17059 8.6928 8.96858 9.20293 9.2202L11.4919 10.3633ZM6.88775 5.69037L7.40441 4.43228L8.54892 3.86435C8.80399 3.73494 8.80399 3.33955 8.54892 3.21014L7.40441 2.64221L6.88775 1.37693C6.77003 1.09656 6.41032 1.09656 6.2926 1.37693L5.77594 2.63502L4.62489 3.20295C4.36983 3.33236 4.36983 3.72776 4.62489 3.85716L5.7694 4.42509L6.28606 5.69037C6.40379 5.97074 6.77003 5.97074 6.88775 5.69037Z",
    fill: "#1777CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilotSuggest);
export default __webpack_public_path__ + "static/media/copilot-suggest.c97edfb81d0f7d5615733ae23846bb59.svg";
export { ForwardRef as ReactComponent };